import React, { useEffect, useMemo, useState } from "react";
import { classNames } from "../../helpers/classNames";

const Badge = ({ type, label = "Label", className, customColor }) => {
  const [statusColor, setStatusColor] = useState();
  const status = useMemo(
    () => ({
      success: "bg-gradient-to-r from-green-600 via-green-700 to-green-800 text-white border border-green-700/50",
      danger: "bg-gradient-to-r from-rose-500 via-rose-600 to-rose-700 text-white border border-rose-700/50",
      warning: "bg-gradient-to-r from-amber-600 via-amber-700 to-amber-800 text-white border border-amber-700/50",
      info: "bg-gradient-to-r from-sky-600 via-sky-700 to-sky-800 text-white border border-sky-700/50",
      indigo: "bg-gradient-to-r from-indigo-600 via-indigo-700 to-indigo-800 text-white border border-indigo-700/50",
      stone: "bg-gradient-to-r from-stone-600 via-stone-700 to-stone-800 text-white border border-stone-700/50",
      gold: "bg-gradient-to-r from-yellow-700 via-amber-700 to-yellow-800 text-white border border-amber-600/50",
      default: "bg-gradient-to-r from-gray-600 via-gray-700 to-gray-800 text-white border border-gray-700/50",
      "": "",
    }),
    []
  );

  useEffect(() => {
    if (type) {
      setStatusColor(status[type]);
    }
  }, [type]);

  return (
    <div
      className={classNames(
        "whitespace-nowrap truncate capitalize text-center py-[2px] px-2 rounded text-xs",
        customColor ? customColor : statusColor,
        className
      )}
    >
      {label}
    </div>
  );
};

export default Badge;
